import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import {GROUPED_BY} from "@constants";
import {useRepricingFormData} from "../../@hooks";


const OPTIONS = [
	{ label: 'Market', value: 'market' },
	{ label: 'Retailer', value: GROUPED_BY.RETAILER },
	{ label: 'Brand', value: GROUPED_BY.BRAND },
	{ label: 'Sku', value: GROUPED_BY.SKU },
	{ label: 'Stock', value: GROUPED_BY.STOCK }
]

export default function RepricingFormScopeCriterionSelect({ criterion }) {
	const { criterionDisplayed, handleChangeScopeValue } = useRepricingFormData(criterion)

    return <SelectSeeker
		options={OPTIONS.filter(({ value }) => criterion ===  value || !criterionDisplayed.includes(value))}
		value={criterion}
		onChange={e => handleChangeScopeValue('key', e.target.value)}
	/>
}